import React from "react";
import { Box, SwipeableDrawer } from "@material-ui/core";
import DrawerHeader from "./DrawerHeader";
import { useStyles } from "./styles";

type Anchor = "top" | "left" | "bottom" | "right";

type Props = {
  isOpen: boolean;
  closeDrawer: any;
  children: any;
  heading: string;
  drawerWidth?: number;
};

export default function CommonDrawer({
  isOpen,
  closeDrawer,
  children,
  heading,
  drawerWidth,
}: Props) {
  const classes = useStyles();
  const [anchorState, setAnchorState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  React.useEffect(() => {
    handleToggleDrawer(isOpen);
  }, [isOpen]);

  const handleToggleDrawer = (isOpen: boolean) => {
    setAnchorState({ ...anchorState, right: isOpen });
  };

  const handleCloseDrawer = () => {
    setAnchorState({ ...anchorState, right: false });
    closeDrawer();
  };

  const toggleDrawer =
    (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }
      setAnchorState({ ...anchorState, [anchor]: open });
      closeDrawer();
    };

  return (
    <>
      <Box>
        {(["right"] as Anchor[]).map((anchor) => (
          <React.Fragment key={anchor}>
            <SwipeableDrawer
              anchor={anchor}
              className={classes.CustomMuiDrawer}
              open={anchorState[anchor]}
              onClose={toggleDrawer(anchor, false)}
              onOpen={toggleDrawer(anchor, true)}
            >
              <Box ml={2} style={{ width: drawerWidth ? drawerWidth : 300 }}>
                <DrawerHeader heading={heading} closeDrawer={handleCloseDrawer} />
                {children}
              </Box>
            </SwipeableDrawer>
          </React.Fragment>
        ))}
      </Box>
    </>
  );
}
